import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { colors } from "@mui/material";


function UnitNetAdd() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [netAddOptions, setNetAddOptions] = useState([]);
  const [weekHeaders, setWeekHeaders] = useState([]);
  const [groupedData, setGroupedData] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  
  const [selectedYear, setSelectedYear] = useState(currentFY);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_unit_netadd/`,
        {
            params: { year: selectedYear},
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setNetAddOptions(response.data.netadd_data || []);
        const lastWeekNetAddColumns = response.data.weekly_netadd_data || [];
		const groupedData = {};
		const weekHeaders = [];
		/* Create headers + grouped structure */
		lastWeekNetAddColumns.forEach((item) => {

		/* Week Headers */
		if (
			!weekHeaders.find(
			(w) => w.week_no === item.week_no
			)
		) {
			weekHeaders.push({
			week_no: item.week_no,
			week_label: item.week_label,
			});
		}

		/* Bu Head Grouping */
		if (!groupedData[item.bu_head]) {
			groupedData[item.bu_head] = {};
		}

		groupedData[item.bu_head][item.week_no] =
			item.revenue;
		});

		/* Sort latest week first */
		weekHeaders.sort((a, b) => b.week_no - a.week_no);	
		setWeekHeaders(weekHeaders);
		setGroupedData(groupedData);

        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
        // setoptions([]);
    } finally {
        setGlobalLoading(false); 
    }
  }

  useEffect(() => {
    if (token && selectedYear) {
        fetchOptions();
    }
  }, [token, selectedYear]); 

  const financialYears = Array.from({ length: 4 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 100px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          }    
        `}
        </style>  
  
        <div className="card shadow-sm mb-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                  <h4 className="mb-0">Net Add Contribution</h4>
                <div style={{ width: "150px" }}>
                    <select
                    className="form-select"
                    value={selectedYear}
                    onChange={(e) => setSelectedYear(e.target.value)}
                    >
                    {financialYears.map((fy) => (
                        <option key={fy.value} value={fy.value}>
                        {fy.label}
                        </option>
                    ))}
                    </select>
                </div>
                </div>

            <div className="table-responsive" style={{ maxHeight: "650px" }}>
              <table className="table text-nowrap table-bordered">
                <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1}}>
                  <tr>
                    <th className="sticky-col-1">Unit Head</th>
                    <th className="sticky-col-2">Total Changes</th>
                    <th>Q1</th>
                    <th>Q2</th>
                    <th>Q3</th>
                    <th>Q4</th>
                    <th>Apr</th>
                    <th>May</th>
                    <th>Jun</th>
                    <th>Jul</th>
                    <th>Aug</th>
                    <th>Sep</th>
                    <th>Oct</th>
                    <th>Nov</th>
                    <th>Dec</th>
                    <th>Jan</th>
                    <th>Feb</th>
                    <th>Mar</th>
                  </tr>
                </thead>

                <tbody>
                  {netAddOptions.map((row, index) => (
                    <tr>
                      <td className="sticky-col-1">{row.bu_head}</td>
                      <td className="sticky-col-2">{formatNumber(row.revenue)}</td>
                      <td>{formatNumber(row.Q1)}</td>
                      <td>{formatNumber(row.Q2)}</td>
                      <td>{formatNumber(row.Q3)}</td>
                      <td>{formatNumber(row.Q4)}</td>
                      <td>{formatNumber(row.Apr)}</td>
                      <td>{formatNumber(row.May)}</td>
                      <td>{formatNumber(row.Jun)}</td>
                      <td>{formatNumber(row.Jul)}</td>
                      <td>{formatNumber(row.Aug)}</td>
                      <td>{formatNumber(row.Sep)}</td>
                      <td>{formatNumber(row.Oct)}</td>
                      <td>{formatNumber(row.Nov)}</td>
                      <td>{formatNumber(row.Decr)}</td>
                      <td>{formatNumber(row.Jan)}</td>
                      <td>{formatNumber(row.Feb)}</td>
                      <td>{formatNumber(row.Mar)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="card shadow-sm mb-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">
                <h4 className="mb-0">Weekly Net Add  <small className="text-muted">(Only current year)</small></h4>
            </div>

            <div className="table-responsive" style={{ maxHeight: "650px" }}>
              <table
                    className="table table-bordered mb-0"
                    style={{
                    tableLayout: "fixed",
                    width: "100%",
                    fontSize: "11px",
                    }}
                >
                    <thead
                    className="table-dark"
                    style={{
                        position: "sticky",
                        top: 0,
                        zIndex: 1,
                    }}
                    >
                    <tr>
                        <th
                        style={{
                            minWidth: "160px",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                        }}
                        >
                        </th>

                        {weekHeaders.map((week) => (
                        <th
                            key={week.week_no}
                            style={{
                            minWidth: "90px",
                            textAlign: "center",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            padding: "6px",
                            lineHeight: "14px",
                            fontSize: "11px",
                            }}
                        >
                            {week.week_label}
                        </th>
                        ))}
                    </tr>
                    </thead>

                    <tbody>
                    {Object.keys(groupedData).map((bu_head) => (
                        <tr key={bu_head}>
                        <td
                            style={{
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                            lineHeight: "14px",
                            padding: "6px",
                            }}
                        >
                            {bu_head}
                        </td>

                        {weekHeaders.map((week) => {
                            const value =
                            groupedData[bu_head][week.week_no];

                            return (
                            <td
                                key={week.week_no}
                                style={{
                                textAlign: "right",
                                padding: "6px",
                                whiteSpace: "nowrap",
                                color: value < 0 ? "red" : "inherit",
                                }}
                            >
                                {value === 0
                                ? "-"
                                : formatNumber(value)}
                            </td>
                            );
                        })}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
          </div>
        </div>
        </>
    );
}

export default UnitNetAdd;